module.exports = __webpack_public_path__ + "assets/img/CY.949ec92e.png";